import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { wellnesTicketTypeToKr } from "../../../wellnessTicket/model";
import { getReservationAndCheckInStatusToText } from "../../../../utils/statusText";

const reservedColumnsV2: ColumnsType<IReservedWellnessLecture> = [
    { title: '클래스명', dataIndex: 'wellnessLectureName', },
    { title: '코치', dataIndex: 'teacherName', },
    { title: '시작시간', dataIndex: 'startDateTime', render: q => dayjs(q).format('YYYY.MM.DD HH:mm') },
    { title: '종료시간', dataIndex: 'endDateTime', render: q => dayjs(q).format('YYYY.MM.DD HH:mm') },
    { title: '장소', dataIndex: 'room', },
    { title: "출석상태", dataIndex: "autoCheckInStatus", render: q => getReservationAndCheckInStatusToText(q) },
    { title: '자동 체크인', dataIndex: 'isAutoCheckIn', render: q => q ? 'Y' : 'X' }
]
const ableCheckInColumnsV2: ColumnsType<IAbleCheckInWellnessLecture> = [
    { title: '클래스명', dataIndex: 'wellnessLectureName', },
    { title: '코치', dataIndex: 'teacherName', },
    { title: '시작시간', dataIndex: 'startDateTime', render: q => dayjs(q).format('YYYY.MM.DD HH:mm') },
    { title: '종료시간', dataIndex: 'endDateTime', render: q => dayjs(q).format('YYYY.MM.DD HH:mm') },
    { title: '장소', dataIndex: 'room', },
    { title: '숨김여부', dataIndex: 'isDelete', render: q => q ? '숨김' : '' },
    { title: '예약 현황', dataIndex: 'maxReservationMember', render: (i, j) => <>{j.nowReservationCnt + " / " + i}</> }
]

const issuedWellnessTicketColumn: ColumnsType<IIssuedWellnessTicketAdminMyByMemberIdResponse> = [
    {
        title: '정기권명', dataIndex: 'name',
        render: (value, record) => <div><div style={{ width: 'fit-content', borderRadius: 7, padding: 10, background: `linear-gradient(135deg, ${record.startColor}, ${record.endColor})`, color: record.textColor }}
        >{`${value} (${wellnesTicketTypeToKr(record.type)})`}</div></div>
    },
    { title: '잔여 횟수', dataIndex: 'remainingCnt', render: q => `${q} 회` },
    { title: '사용기간', render: (_, w) => `${dayjs(w.startDate).format("YYYY.MM.DD")} ~ ${dayjs(w.expiredDate).format("YYYY.MM.DD")}` },
    { title: '잔여일', dataIndex: 'expiredDate', render: q => dayjs(q).diff(dayjs(), 'd') }
]

export { reservedColumnsV2, ableCheckInColumnsV2, issuedWellnessTicketColumn }